/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Alias
 */
export interface Alias {
  /**
   *
   * @type {string}
   * @memberof Alias
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Alias
   */
  externalSystem: AliasExternalSystemEnum;
  /**
   *
   * @type {string}
   * @memberof Alias
   */
  alias: string;
}

export const AliasExternalSystemEnum = {
  Fishtalk: 'Fishtalk',
  Mercatus: 'Mercatus',
  Aquabyte: 'Aquabyte',
  Optoscale: 'Optoscale',
  Tidal: 'Tidal',
} as const;

export type AliasExternalSystemEnum = (typeof AliasExternalSystemEnum)[keyof typeof AliasExternalSystemEnum];
